<template>
  <layout-card-wrap
    v-loading="loading"
    hasHeaderSlot>
    <template slot="title">全期数据</template>
    <el-row>
      <el-col :span="24">
        <summary-list
          :span="6"
          :list="summaryList" />
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-row :gutter="20">
      <el-col :span="12">
        <!-- <v-title title="本期访问流量情况" /> -->
        <line-chart
          title="本期访问流量情况"
          :fetch="statswxuserlogincount" />
      </el-col>
      <el-col :span="12">
        <!-- <v-title title="本期访问入口情况" /> -->
        <line-chart
          title="本期访问入口情况"
          :fetch="statswxuserloginentry" />
      </el-col>
      <el-col :span="12">
        <!-- <v-title title="本期访问入口情况" /> -->
        <line-chart
          title="会员周/月新增情况"
          :fetch="statswxuserregcount" />
      </el-col>
    </el-row>
  </layout-card-wrap>
</template>

<script>
import SummaryList from './busi/summary.vue'
import LineChart from './customer/line-chart.vue'
// import VTitle from './v-title.vue'
import moment from 'moment'
export default {
  name: 'StatCustomerNew',
  components: { SummaryList, LineChart },
  data() {
    return {
      loading: false,
      summaryList: [
        {
          label: '会员总数',
          value: 0
        },
        {
          label: '访客总数',
          value: 0
        },
        {
          label: '订单金额',
          value: 0
        },
        {
          label: '订单总数',
          value: 0
        }
      ]
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.loading = true
      this.$store.dispatch('overview/summary', {
        payload: {},
        success: (res) => {
          this.loading = false
          console.log(res)
          this.$set(this, 'summaryList', [
            {
              label: '会员总数',
              value: res.data.totalMemberCount
            },
            {
              label: '用户总数',
              value: res.data.totalUserCount
            },
            {
              label: '订单金额',
              value: res.data.totalCashOrderAmount
            },
            {
              label: '订单总数',
              value: res.data.totalCashOrderCount
            }
          ])
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    statswxuserlogincount(payload, success, fail) {
      this.$store.dispatch('overview/statswxuserlogincount', {
        payload,
        success: res => {
          const timeUnit = payload.timeUnit
          const xAxis = []
          const s1 = {
            data: [],
            type: 'line',
            name: '访客数',
            smooth: true
          }
          const s2 = {
            data: [],
            type: 'line',
            name: '会员数',
            smooth: true
          }
          res.data.loginCountSummarys.forEach(i => {
            const time = timeUnit === 'W' ? `${moment(i.statTime, 'YYYYMMDD').format('YYYY/MM/DD')}-${moment(i.endTime, 'YYYYMMDD').format('YYYY/MM/DD')}` : moment(i.statTime, 'YYYYMMDD').format('YYYY/MM')
            xAxis.push(time)
            s1.data.push(i.loginCount)
            s2.data.push(i.memberLoginCount)
          })
          success && success({
            xAxis,
            series: [s1, s2]
          })
        },
        fail: () => {
          fail && fail()
        }
      })
    },
    statswxuserloginentry(payload, success, fail) {
      this.$store.dispatch('overview/statswxuserloginentry', {
        payload,
        success: res => {
          const timeUnit = payload.timeUnit
          const xAxis = []
          const s1 = {
            data: [],
            type: 'line',
            name: '朋友转发',
            smooth: true
          }
          const s2 = {
            data: [],
            type: 'line',
            name: '扫码进入',
            smooth: true
          }
          const s3 = {
            data: [],
            type: 'line',
            name: '搜索进入',
            smooth: true
          }
          res.data.loginEntrySummarys.forEach(i => {
            const time = timeUnit === 'W' ? `${moment(i.statTime, 'YYYYMMDD').format('YYYY/MM/DD')}-${moment(i.endTime, 'YYYYMMDD').format('YYYY/MM/DD')}` : moment(i.statTime, 'YYYYMMDD').format('YYYY/MM')
            xAxis.push(time)
            s1.data.push(i.forwardLoginCount)
            s2.data.push(i.scanTagLoginCount)
            s3.data.push(i.searchLoginCount)
          })
          success && success({
            xAxis,
            series: [s1, s2, s3]
          })
        },
        fail: () => {
          fail && fail()
        }
      })
    },
    statswxuserregcount(payload, success, fail) {
      this.$store.dispatch('overview/statswxuserregcount', {
        payload,
        success: res => {
          const timeUnit = payload.timeUnit
          const xAxis = []
          const s1 = {
            data: [],
            type: 'line',
            name: '新用户数量',
            smooth: true
          }
          const s2 = {
            data: [],
            type: 'line',
            name: '会员数',
            smooth: true
          }
          res.data.userRegSummarys.forEach(i => {
            const time = timeUnit === 'W' ? `${moment(i.statTime, 'YYYYMMDD').format('YYYY/MM/DD')}-${moment(i.endTime, 'YYYYMMDD').format('YYYY/MM/DD')}` : moment(i.statTime, 'YYYYMMDD').format('YYYY/MM')
            xAxis.push(time)
            s1.data.push(i.regCount)
            s2.data.push(i.memberCount)
          })
          success && success({
            xAxis,
            series: [s1, s2]
          })
        },
        fail: () => {
          fail && fail()
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
    .grid-content {
        height 300px;
    }
</style>
